import Button from 'components/Button';
import { useState } from 'react';
import SaleAdjustmentModal from '../SaleAdjustment/SaleAdjustmentModal';

const ButtonSaleAdjustment = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button ntype='TERTIARY' icon='AdjustSale' className='btn-print' onClick={() => setVisible(true)}>
        Sale Adjustment
      </Button>
      <SaleAdjustmentModal visible={visible} setVisible={() => setVisible(false)} />
    </>
  );
};

export default ButtonSaleAdjustment;